import { render, staticRenderFns } from "./IndustryBlacklist.vue?vue&type=template&id=4adf0f7e&scoped=true&"
import script from "./IndustryBlacklist.vue?vue&type=script&lang=js&"
export * from "./IndustryBlacklist.vue?vue&type=script&lang=js&"
import style0 from "./IndustryBlacklist.vue?vue&type=style&index=0&id=4adf0f7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adf0f7e",
  null
  
)

export default component.exports